import { render, staticRenderFns } from "./ChangedStatusAlert.vue?vue&type=template&id=935560da&scoped=true"
import script from "./ChangedStatusAlert.vue?vue&type=script&lang=js"
export * from "./ChangedStatusAlert.vue?vue&type=script&lang=js"
import style0 from "./ChangedStatusAlert.vue?vue&type=style&index=0&id=935560da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935560da",
  null
  
)

export default component.exports